import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import '../client/temp-common-imports';

export class NotFoundController implements Controller {
  public pageId = '404';
  public path = '*';
  public routeName = 'notfound';
  public exact = true;
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "not-found-page" */ '../views/not-found-page'));

  public fetch(options: FetchOptions) {
    return Promise.resolve({});
  }

  public fetchPageData() {
    return Promise.resolve({ title: 'Page Not Found' });
  }
}
